import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/store';
import HomePage from '@/components/index.vue';
import PlotsPage from '@/components/plots.vue';
import ProjectsPage from '@/components/projects.vue';
import TransactionsPage from '@/components/transactions.vue';
import SelfSortPage from '@/components/self-sort.vue';
import ProfilePage from '@/components/profile.vue';
import LoginPage from '@/components/login.vue';

const routes = [
  { path: '/', name: 'Home', component: HomePage, meta: { requiresAuth: true } },
  { path: '/plots', name: 'Plots', component: PlotsPage, meta: { requiresAuth: true } },
  { path: '/projects', name: 'Projects', component: ProjectsPage, meta: { requiresAuth: true } },
  { path: '/transactions', name: 'Transactions', component: TransactionsPage, meta: { requiresAuth: true } },
  { path: '/self-sort', name: 'SelfSort', component: SelfSortPage, meta: { requiresAuth: true } },
  { path: '/profile', name: 'Profile', component: ProfilePage, meta: { requiresAuth: true } },
  { path: '/user-login', name: 'Login', component: LoginPage },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

// Route guard to protect private routes
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('access_token');
  const store = useUserStore();
  
  // If the route requires authentication and the user is not authenticated, redirect to login
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/user-login');
  }
  // Force profile update if must_change_password is set
  else if (isAuthenticated && store.mustChangePassword && to.name !== 'Profile' && to.name !== 'Login') {
    next({ path: '/profile', query: { update: 'required' } });
  } else {
    next();
  }
});

// Reset scroll position on route change (targets the .app-content container)
router.afterEach(() => {
  const appContent = document.querySelector('.app-content');
  if (appContent) {
    appContent.scrollTop = 0;
  }
});

export default router;
